module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp23_6005.9f00d896.png";